import { CustomFieldAPI } from 'core/service/custom-fields/custom-field.type';
import { useCustomFields } from 'core/contexts/custom-fields/use-custom-fields.hook';
import React, { useEffect } from 'react';
import { AutomationRulesDropdownOptions } from '../components/automation-rules-dropdown.component';
import { TriggerExternalConditions } from '../constants/backend-enums';
import { AutomationRuleOption, useAutomationRuleOptionsState } from '../hooks/use-automation-rule-options-state';
import { TriggerLayout } from '../layouts/trigger.layout';
import {
    ExternalOptions,
    OnChangeAutomationRuleStateData,
    TriggerActionDataParams,
} from '../types/automation-rules.type';

const mapCustomFieldsToOptions = (customFields: CustomFieldAPI[]) =>
    customFields.map((customField) => ({
        id: customField.id,
        value: TriggerExternalConditions.custom_field,
        label: customField.name,
    }));

interface TriggerContainerProps {
    defaultOptions: AutomationRuleOption[];
    whenTriggerOptions: AutomationRulesDropdownOptions[];
    defaultWhenTrigger: ExternalOptions;
    newTriggerDefault: React.ReactElement;
    onAddDeleteGlobalState: (data: TriggerActionDataParams) => void;
    onChange: (data: OnChangeAutomationRuleStateData) => void;
}

export const TriggerContainer = (props: TriggerContainerProps) => {
    const { operatorsCustomFields, isLoading: isCustomFieldLoading } = useCustomFields();
    const {
        defaultOptions,
        whenTriggerOptions,
        defaultWhenTrigger,
        newTriggerDefault,
        onAddDeleteGlobalState,
        onChange,
    } = props;

    const { options, onDeleteOptionHandler, onAddOptionHandler } = useAutomationRuleOptionsState({
        defaultOptions,
        newOptionDefault: newTriggerDefault,
        onAddDeleteGlobalState,
    });

    const [externalOptions, setExternalOptions] = React.useState<ExternalOptions[]>([
        ...mapCustomFieldsToOptions(operatorsCustomFields),
    ]);

    useEffect(() => {
        setExternalOptions(mapCustomFieldsToOptions(operatorsCustomFields));
    }, [operatorsCustomFields]);

    return (
        <TriggerLayout
            conditionOptions={options}
            isLoading={isCustomFieldLoading}
            whenTriggerOptions={whenTriggerOptions}
            defaultWhenTrigger={defaultWhenTrigger}
            externalOptions={externalOptions}
            onDeleteOptionHandler={onDeleteOptionHandler}
            onAddActionHandler={onAddOptionHandler}
            onChange={onChange}
        />
    );
};
